// extracted by mini-css-extract-plugin
export default {"buttonPill":"button-pill__buttonPill___sOPje"};